import * as React from "react"

const SvgComponent = (props) => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_40435_2687)">
        <path d="M40.3122 35.6286H5.47551C3.97295 35.6286 2.86957 34.4096 3.01245 32.907L4.70666 15.0952C4.84954 13.5926 6.18427 12.3735 7.68796 12.3735H42.5247C44.0272 12.3735 45.1306 13.5926 44.9877 15.0952L43.2935 32.907C43.1506 34.4096 41.8159 35.6286 40.3133 35.6286H40.3122Z" fill="#4F87FF"/>
        <path d="M9.7832 16.6606L19.9609 25.2848C22.0259 27.0345 25.0469 27.1786 27.2764 25.6318L40.2086 16.6606" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.9951 24.811L7.94531 32.4758" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M38.3705 32.4756L28.9355 24.4797" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_40435_2687">
        <rect width="42.0002" height="23.2551" fill="white" transform="translate(3 12.3726)"/>
        </clipPath>
        </defs>
    </svg>
    );

export default SvgComponent;